import { render } from "./RatesPage.vue?vue&type=template&id=3d8037a6"
import script from "./RatesPage.vue?vue&type=script&lang=js"
export * from "./RatesPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__